/* eslint-disable no-param-reassign */
import { createAction, createReducer, createSelector } from '@reduxjs/toolkit';
import hondaRestApi from '../apis/hondaRestApi';
export var INITIAL_STATE = {
    trimsWithPaymentAndOffers: [],
    pendingPaymentKeys: [],
    isLoyaltyFilterChecked: false,
};
export var setIsLoyaltyFilterChecked = createAction('specialOffers/toggleIsLoyaltyFilterChecked');
export var setTrimsWithPaymentAndOffers = createAction('specialOffers/setTrimsWithPaymentAndOffers');
var specialOffersReducer = createReducer(INITIAL_STATE, function (builder) {
    builder
        .addCase(setTrimsWithPaymentAndOffers, function (state, action) {
        state.trimsWithPaymentAndOffers = action.payload;
    })
        .addCase(setIsLoyaltyFilterChecked, function (state, action) {
        state.isLoyaltyFilterChecked = action.payload;
    })
        .addMatcher(hondaRestApi.endpoints.getPayment.matchFulfilled, function (state, action) {
        var payment = action.payload.transformedData;
        if (!state.trimsWithPaymentAndOffers.length || !payment)
            return state;
        var _loop_1 = function (trim) {
            // eslint-disable-next-line no-continue
            if (trim.transmissionKey !== payment.detKeys.transmissionKey)
                return "continue";
            trim.payment = payment;
            state.pendingPaymentKeys = state.pendingPaymentKeys.filter(function (key) { return key !== trim.transmissionKey; });
            return "break";
        };
        // eslint-disable-next-line no-restricted-syntax
        for (var _i = 0, _a = state.trimsWithPaymentAndOffers; _i < _a.length; _i++) {
            var trim = _a[_i];
            var state_1 = _loop_1(trim);
            if (state_1 === "break")
                break;
        }
    })
        .addMatcher(hondaRestApi.endpoints.getPayment.matchRejected, function (state, action) {
        var transmissionKey = action.meta.arg.originalArgs.body.transmissionKey;
        if (!state.trimsWithPaymentAndOffers.length || !transmissionKey)
            return state;
        state.pendingPaymentKeys = state.pendingPaymentKeys.filter(function (key) { return key !== transmissionKey; });
    })
        .addMatcher(hondaRestApi.endpoints.getPayment.matchPending, function (state, action) {
        var transmissionKey = action.meta.arg.originalArgs.body.transmissionKey;
        if (!state.trimsWithPaymentAndOffers.length || !transmissionKey)
            return state;
        state.pendingPaymentKeys.push(transmissionKey);
    });
});
export var selectSpecialOffers = function (state) { return state.specialOffers; };
export var selectTrimsWithPaymentAndOffers = createSelector(selectSpecialOffers, function (specialOffers) { return specialOffers.trimsWithPaymentAndOffers; });
export var selectIsLoyaltyFilterChecked = function (state) { return state.specialOffers.isLoyaltyFilterChecked; };
export var selectIsTrimPaymentLoading = function (state, transmissionKey) {
    return state.specialOffers.pendingPaymentKeys.includes(transmissionKey);
};
export default specialOffersReducer;
